import {EventEmitter, Component, ElementRef, HostListener, Input, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {RewardsToasterEvent, RewardsToasterType} from '../../../shared/services/rewards-toaster.interface';

declare var $: any;

@Component({
    selector: 'app-rewards-toaster',
    templateUrl: './rewards-toaster.component.html',
    styleUrls: ['./rewards-toaster.component.scss']
})
export class RewardsToasterComponent implements OnInit {
    @Input() data;
    @Input() options;
    @Input() isOpen = false;

    @Output() toasterEvents = new EventEmitter();
    @ViewChild('ToasterMessageContainer', {read: ViewContainerRef, static: true}) ToasterMessageContainer: ViewContainerRef;
    @ViewChild('DSTV2ToasterTemplate', {read: TemplateRef, static: true}) DSTV2ToasterTemplate: TemplateRef<any>;

    toasterTypeEnum = RewardsToasterType;

    constructor(public elementRef: ElementRef) {
    }

    ngOnInit(): void {
        this.loadToasterMessage();
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setUserMessageEvents(`toast-message|${this.data?.message}`);
        }
        if(this.data.autoCloseTime) {
            setTimeout(() => {
                this.closeToasterEvent();
            }, this.data.autoCloseTime)
        }
    }

    // this closes the toast when the user clicks off the toast
    @HostListener('document:click', ['$event'])
    onMouseUp(e: any): void {
        if (this.isOpen) {
            const container = this.elementRef.nativeElement;
            !container.contains(e.target) && this.closeToasterEvent();
        }
    }

    continueToasterEvent(): void {
        const event: RewardsToasterEvent = {type: 'continue'};
        this.toasterEvents.emit(event);
    }

    closeToasterEvent(): void {
        const event: RewardsToasterEvent = {type: 'close'};
        this.toasterEvents.emit(event);
    }

    rollBackFocusClose() {
        this.elementRef.nativeElement.focus();
    }

    closeToasteronParentFocus() {
        this.closeToasterEvent();
    }

    public loadToasterMessage(): void {
        this.ToasterMessageContainer.createEmbeddedView(this.DSTV2ToasterTemplate);
    }

  closeToasterEventFromKey(e) {
    if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
      this.closeToasterEvent();
    }
  }

}

